import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app.routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AuthService } from './global-services/auth.service';
import { SsoAuthService } from './global-services/sso.service';
import { LoggedInGuard } from './guard/logged-in-guard';
import { CookieService } from 'ngx-cookie-service';
import { DbcModule } from './dbc/dbc.module';
import { SsoLoginComponent } from './pages/sso-login.component';
import { FormsModule } from '@angular/forms';
import { SsoLogoutComponent } from './pages/sso-logout.component';
import { provideHttpClient } from '@angular/common/http';
import { LandingPageComponent } from './global-components/desktop-landing-page/landing-page.component';
import { MobLandingPageComponent } from './global-components/mobile-landing-page/mob-landing-page.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DeviceGuard } from './guard/device-guard';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { TopNavComponent } from './global-components/top-nav-bar/top-nav/top-nav.component';
import { OptionsComponent } from './global-components/options/options.component';
import { MobileDrawerModule } from './global-components/mobile-drawer/mobile-drawer.module';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { DbcService } from './global-services/dbc.service';
import { AccountDrawerComponentComponent } from './global-components/account-drawer-component/account-drawer-component.component';
import { PwaInstallNudgeComponent } from './global-components/pwa-install-nudge/pwa-install-nudge.component';
import { register as swiperRegister } from 'swiper/element';
import { ExternalUrlServiceService } from './global-services/external-url-service.service';
import { AmplitudeService } from './global-services/amplitude.service';
import { IosInstallDrawerModule } from './global-components/ios-install-drawer/ios-install-drawer.module';
import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { indexedDBConfig } from './index-db';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LeadService } from './global-services/lead.service';
import { PostSignupLandingModule } from './pages/post-signup-landing/post-signup-landing.module';
import { WaitLoaderModule } from './global-components/wait-loader/wait-loader.module';
import { ModalComponent } from './global-components/modal/modal.component';
import { DownloadCardsAppTopbarMobileNudgeModule } from './global-components/download-cards-app-topbar-mobile-nudge/download-cards-app-topbar-mobile-nudge.module';
import { NudgesService } from './global-services/nudges.service';

const indexDBconfig: DBConfig = indexedDBConfig;

swiperRegister();

@NgModule({
    declarations: [
        AppComponent,
        SsoLoginComponent,
        SsoLogoutComponent,
        LandingPageComponent,
        MobLandingPageComponent,
        FullLayoutComponent,
        TopNavComponent,
        OptionsComponent,
        AccountDrawerComponentComponent,
        PwaInstallNudgeComponent,
        ModalComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        DbcModule,
        FormsModule,
        MobileDrawerModule,
        IosInstallDrawerModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:10000',
        }),
        InfiniteScrollDirective,
        NgxIndexedDBModule.forRoot(indexDBconfig),
        NgxSkeletonLoaderModule,
        PostSignupLandingModule,
        WaitLoaderModule,
        DownloadCardsAppTopbarMobileNudgeModule
    ],
    providers: [
        AuthService,
        SsoAuthService,
        CookieService,
        LoggedInGuard,
        provideHttpClient(),
        DeviceGuard,
        DeviceDetectorService,
        ExternalUrlServiceService,
        DbcService,
        AmplitudeService,
        LeadService,
        NudgesService,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
